import React, { useEffect } from 'react';
import { Navigation } from '@/components/navigation';
import { Hero } from '@/components/hero';
import { Features } from '@/components/features';
import { BeforeAfter } from '@/components/before-after';
import { TTSPlayground } from '@/components/tts-playground';
import { Testimonials } from '@/components/testimonials';
import { Pricing } from '@/components/pricing';
import { FAQ } from '@/components/faq';
import { FloatingCTA } from '@/components/floating-cta';
import { Footer } from '@/components/footer';
import "./index.css";

export function App() {
  useEffect(() => {
    // Initialize scroll reveal animations
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px',
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const delay = entry.target.getAttribute('data-delay') || '0';
          setTimeout(() => {
            entry.target.classList.add('revealed');
          }, parseInt(delay));
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe all elements with scroll animation classes
    const animatedElements = document.querySelectorAll('.scroll-fade-up, .scroll-scale, .scroll-slide-left, .scroll-slide-right');
    animatedElements.forEach((el) => observer.observe(el));

    return () => {
      animatedElements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main>
        <Hero />
        <Features />
        <BeforeAfter />
        <TTSPlayground />
        <Testimonials />
        <Pricing />
        <FAQ />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}

export default App;
